export default "__VITE_ASSET__70482653__"